import React from "react";
import { useNavigate } from "react-router-dom";

import { IgAlert } from "@intelligems/ig-theme/IgAlert";
import { IgLink } from "@intelligems/ig-theme/IgLink";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useReadOnlyMode } from "@src/features/publicShareLinks/hooks/useReadOnlyMode";
import { SETTINGS_ROUTES } from "@src/routes/routes";
import { SettingsSectionId } from "@src/types/navigation";
import { productGroupsLink } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

interface ProductGroupBannerProps {
  hasProductGroups: boolean;
}

export const ProductGroupBanner = ({
  hasProductGroups,
}: ProductGroupBannerProps) => {
  const navigate = useNavigate();
  const { isReadOnly } = useReadOnlyMode();
  return (
    <IgAlert
      alertKey={"123"}
      title={
        hasProductGroups
          ? "Want to add or modify your product groups?"
          : "Product Groups let you analyze your results by product category"
      }
      severity={"info"}
      primaryButton={{
        onClick: () => {
          void navigate(
            `${SETTINGS_ROUTES.Settings}#${SettingsSectionId.Cogs}`
          );
        },
        cta: "Manage Product Groups",
        disabled: isReadOnly,
        tooltipMessage: isReadOnly ? "You are in a read only view." : "",
      }}
      message={
        <IgTypography>
          {hasProductGroups
            ? "To change your existing product groups or create new ones, upload them as part of your COGS spreadsheet."
            : "You don’t have any product groups. To define some, upload them as part of your COGS spreadsheet."}{" "}
          <IgLink
            onClick={() => {
              openNewTab(productGroupsLink, {
                mixpanelTracker: "Product Groups",
              });
            }}
          >
            Find out more.
          </IgLink>
        </IgTypography>
      }
    />
  );
};
